<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main" id="page-content-main">
    <!-- <epay-lib-employer-register [baseurl]="baseurl" [termsContent]="termsContent" [loginHelp]="loginHelp"
      [canCreateNewEmployer]="canCreateNewEmployer" [useEmailForLogin]="useEmailForLogin">
    </epay-lib-employer-register> -->

    <epay-common-employer-register [baseurl]="baseurl" [termsContent]="termsContent" [loginHelp]="loginHelp"
      [canCreateNewEmployer]="canCreateNewEmployer" [useEmailForLogin]="useEmailForLogin">
    </epay-common-employer-register>
  </div>
</epay-page-content>
